export default "__VITE_ASSET__Bj9_zeO4__"